<template>
  <div class="upIphone">
    <el-dialog
      v-if="title"
      :show-close="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      v-model="dialogVisible"
      class="uplphone"
      width="413px"
    >
      <!-- 头部 -->
      <div class="toolTap">
        <div class="toolItem actived">{{ title.title }}</div>
      </div>
      <!-- 短信验证 -->
      <el-form
        :model="ruleForm"
        status-icon
        class="rule-form el-input-div"
        v-if="title.origin === 'user' || title.origin === 'login'"
      >
        <!-- 手机号 -->
        <el-form-item>
          <el-input
            type="text"
            ref="iphone"
            v-model="ruleForm.iphone"
            maxlength="11"
            class="iphone"
            @blur="getCheckuser"
            placeholder="请输入手机号"
          >
            <template #prefix>
              <i class="iconfont icon-zhanghao"></i>
            </template>
          </el-input>
        </el-form-item>
        <!-- 滑块验证 -->
        <el-form-item>
          <div class="verify-div" v-if="slideIsshow">
            <div class="slide-verify-div-box">
              <div class="slide-verify-title">
              <span>请完成安全验证码</span>
              <span @click="slideIsshow = false;slideBtnIsshow = true">x</span>
              </div>
              <div class="slide-verify-box">
                <slide-verify 
                  v-if="slideIsshow"
                  slider-text="拖动做左边滑块完成上方拼图"
                  @success='onSuccess'
                  @fail="onFail"
                ></slide-verify>
              </div>
            </div>
            <div class="mask" @click="slideIsshow = false;slideBtnIsshow = true"></div>
          </div>
          <!-- 滑动验证码 -->
          <el-button-group style="width: 100%;">
            <el-button v-show="slideBtnIsshow" class="verifyBtn mgtb" style="margin-bottom: 0;" @click="showSlide" type="primary">点击完成验证</el-button>
            <el-button v-show="slideSuccessBtn" class="SuccessBtn mgtb"  type="primary">
              <svg t="1652076018727" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1898" width="19" height="19"><path d="M512 0C228.430769 0 0 228.430769 0 512s228.430769 512 512 512 512-228.430769 512-512S795.569231 0 512 0z m0 945.230769C271.753846 945.230769 78.769231 752.246154 78.769231 512S271.753846 78.769231 512 78.769231s433.230769 192.984615 433.230769 433.230769-192.984615 433.230769-433.230769 433.230769z" p-id="1899" fill="#43BF97"></path><path d="M716.8 330.830769l-208.738462 248.123077c-15.753846 15.753846-43.323077 19.692308-59.076923 7.876923L299.323077 472.615385c-15.753846-11.815385-43.323077-7.876923-55.138462 7.876923-11.815385 15.753846-7.876923 43.323077 7.876923 55.138461l149.661539 114.215385c19.692308 15.753846 47.261538 23.630769 74.830769 23.630769 35.446154 0 70.892308-15.753846 94.523077-43.323077l208.738462-248.123077c15.753846-15.753846 11.815385-43.323077-3.938462-55.138461-19.692308-15.753846-43.323077-15.753846-59.076923 3.938461z" p-id="1900" fill="#43BF97"></path></svg>
              验证成功
            </el-button>
          </el-button-group>
        </el-form-item>
        <!-- 手机动态码 -->
        <el-form-item>
          <el-input
            v-model.number="ruleForm.smsVerification"
            ref="smsVerification"
            placeholder="请输入手机动态码"
            class="img-verification"
            style="width: calc(100% - 145px)"
          >
            <template #prefix>
              <i class="iconfont icon-mima1"></i>
            </template>
          </el-input>
          <a :class="verificationCount > 0 ? 'sms-ver-number noSms' : 'sms-ver-number'" @click="countTime">{{ verificationCount === 0 ? "获取验证码" : verificationCount + "秒后重新获取" }}</a>
        </el-form-item>
        <!-- 错误提示 -->
        <div class="error-code" v-show="errorCode">
          {{ errorCode }}
        </div>
        <el-form-item align="center" class="bottomArea">
          <div style="display: flex;justify-content: center;width: 100%;">
            <!-- 取消按钮 -->
            <el-button class="clone-iphone" @click="dialogVisible = false">取消</el-button>
            <!-- 确定按钮 -->
            <el-button type="primary" class="yesBind" :loading="yesLoading" element-loading-text="数据加载中" :style="!ruleForm.smsVerification || !ruleForm.iphone ? 'background:#B4C8D9 !important;border:1px solid #B4C8D9 !important' : ''" @click="yesUp">{{ title.bottom }}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <!-- 密码重置 -->
      <el-form
        :model="paw"
        status-icon
        class="rule-form el-input-div"
        v-if="(title.origin === 'paw' && !isYes) || title.origin === 'renewPaw'"
      >
        <!-- 提示 -->
        <template v-if="title.name">
          <p class="iphone" style="margin: 0 auto 10px">
            请确认账号姓名是您的名字，如果无误，请输入新的密码。
          </p>
          <p style="margin: 0 auto 15px" v-if="jmShow">修改成功后，上网认证密码会同步更新。</p>
          <el-form-item align="center">
            <p class="iphone" style="text-align: left">
              <i class="el-icon-user-solid"></i>
              <span style="font-size: 16px">{{ title.name }}</span>
            </p>
          </el-form-item>
        </template>
        <!-- 用户名 -->
        <el-form-item v-if="userNameArr.length > 1">
          <i class="iconfont icon-yonghuming"></i>
          <el-select
            v-model="title.username"
            placeholder="请选择用户名"
            class="iphone select-name"
            ref="select"
            @change="changeUserName"
          >
            <el-option
              v-for="item in userNameArr"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 学校 -->
        <el-form-item v-if="userSchoolArr.length > 1">
          <i class="iconfont icon-xuexiao"></i>
          <el-select
            v-model="title.userschool"
            placeholder="请选择学校"
            class="iphone select-name"
            ref="selectSchool"
            @change="changeSchool"
          >
            <el-option
              v-for="item in userSchoolArr"
              :key="item.name"
              :label="item.name"
              :value="item.schoolId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 密码 -->
        <el-form-item>
          <el-input type="password" ref="password" class="iphone" placeholder="请输入8-12位密码，超出无效" v-model="paw.password" maxlength="12">
            <template #prefix>
              <i class="iconfont icon-xiugaimima" />
            </template>
          </el-input>
        </el-form-item>
        <!-- 确认密码 -->
        <el-form-item>
          <el-input
            type="password"
            ref="password1"
            class="iphone"
            placeholder="请再次输入8-12位密码，超出无效"
            v-model="paw.password1"
            maxlength="12"
          >
            <template #prefix>
              <i class="iconfont icon-xiugaimima" />
            </template>
          </el-input>
        </el-form-item>
        <!-- 错误提示 -->
        <div class="error-code" v-show="errorCode">
          {{ errorCode }}
        </div>
        <!-- 底部按钮 -->
        <el-form-item align="center" class="bottomArea">
          <el-button
            type="yetext"
            class="clone-iphone"
            @click="dialogVisible = false"
            >信息错误，退出</el-button
          >
          <el-button
            type="primary"
            class="yesBind"
            :loading="pawLoading"
            element-loading-text="数据加载中"
            :style="
              !paw.password ||
              !paw.password1 ||
              (title.username && title.username === '')
                ? 'background: #B4C8D9 !important;border:1px solid #B4C8D9 !important'
                : ''
            "
            @click="yesPaw(paw)"
            >{{ title.bottom }}</el-button
          >
        </el-form-item>
        <el-form-item align="center">
          <div class="note">
            <p>{{ "注："+ tipWords[pwdLevel] }}</p>
            <p v-if="jmShow">新密码生效后，上网认证密码会同步更新！</p>
          </div>          
        </el-form-item>
      </el-form>
      <div class="note-yes-paw" v-if="isYes">
        <i class="iconfont icon-tongyi"></i>
        <div class="note-yes-paw-text">密码重置成功，即将返回登陆页面</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { iphone } from '@/util/util'
import { baseurl } from '@/port/common.js'
import { cloneDeep } from 'lodash'
import { sha1 } from '@/util/sha1.js'
import { emitter } from '@/util/util'
import {
  mobileGetpasswordsmsvalidcode,
  mobileGetuserinfosmsvalidcode,
  openapiBindphone,
  openapiResetpassword,
  apiUpdatemine,
  apiCheckuser,
  openapiValidsliderpasswordcode,
  getuserschoollist
} from '@/port/common/upIphone'
export default {
  data () {
    return {
      baseurl: baseurl(),
      //- 弹窗显示
      dialogVisible: false,
      //- 短信表单数据
      ruleForm: {
        iphone: '',
        imgVerification: '',
        smsVerification: ''
      },
      //- 重置密码表单数据
      paw: {
        password: '',
        password1: ''
      },
      //- 名称
      title: null,
      //- 定时器60s等待值
      verificationCount: 0,
      //- 定时器方法
      countTimeFun: null,
      //- 图形验证码尾缀随机值
      randomNumber: '',
      //- 错误提示
      errorCode: '',
      isYes: false,
      yesLoading: false,
      pawLoading: false,
      userNameArr: [],
      userSchoolArr: [], //学校列表
      pwdconfig: {}, // 密码安全设置相关配置
      isCheckuser: false,
      // 滑动验证码显示
      slideIsshow: false,
      // 滑动验证码按钮显示
      slideBtnIsshow: true,
      // 滑动验证成功后的提示
      slideSuccessBtn: false,
      // 滑动验证的返回
      isVerify: false,
      moveLength: '',
      imagecaptchatoken: '',
      schoolId: null,
      pwdLevel: 2,
      tipWords: [
        '密码最少8位，英文（含大小写）/数字/特殊字符（@、#、$、%、^、& 、*、~、!）三种组合',
        '密码最少8位，英文/数字/特殊字符（@、#、$、%、^、& 、*、~、!）三种组合',
        '密码最少8位，英文/数字 两种组合',
        '密码最少8位，不限制'
      ],
      jmShow: false, //集美教育局差异化显示
    };
  },
  watch: {
    dialogVisible: function (val) {
      if (!val) {
        this.ruleForm = {
          iphone: '',
          imgVerification: '',
          smsVerification: ''
        };
        this.title = null;
        clearTimeout(this.countTimeFun);
        this.countTimeFun = null;
        this.errorCode = '';
        this.randomNumber = '';
        this.verificationCount = 0;
        this.isYes = false;
        this.yesLoading = false;
        this.pawLoading = false;
        this.userNameArr = [];
        this.isCheckuser = false;
      }
    }
  },
  mounted () {
    // 集美教育局差异化显示
    if (this.$url === 'https://guanli.xmjmedu.com' || this.$url === 'https://zhihui.xmycxx.com') {
        this.jmShow = true
    }
  },
  props:{
    isWebSite:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    // 显示滑动验证码
    showSlide(){
      if (!iphone(this.ruleForm.iphone)) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      this.slideIsshow = !this.slideIsshow
    },
    // 滑块验证码的回调
    onSuccess(e){
      this.imagecaptchatoken = e.imagecaptchatoken
      this.moveLength = e.moveLength
      this.slideIsshow = false
      this.slideBtnIsshow = false
      this.slideSuccessBtn = true
      this.isVerify = true
    },
    onFail(){

    },
    onRefresh(){
        console.log('刷新');
    },

    //- 验证手机号是否已经被绑定
    getCheckuser () {
      if (this.title.origin !== 'user') {
        return false;
      }
      this.isCheckuser = true;
      apiCheckuser({ phone: this.ruleForm.iphone }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.isCheckuser = false;
        } else {
          this.errorCode = res.msg;
          this.errorTry('iphone', 1)
        }
      }).catch(error => { console.log(error) });
    },
    //- 获取验证码
    countTime () {
      if (this.verificationCount > 0) {
        // this.$message({
        //   message: '请倒计时结束后再来',
        //   type: 'error'
        // });
        return false;
      }
      if (this.isCheckuser) {
        return false;
      }
      if (!this.verificationFun()) {
        return false
      }
      this.getIphoneVaild();
    },
    //- 判断格式
    verificationFun (e) {
      this.errorCode = '';
      if (this.ruleForm.iphone === '') {
        this.errorCode = '手机号码不能为空';
        this.errorTry('iphone', 1);
        return false;
      }
      if (!iphone(this.ruleForm.iphone)) {
        this.errorCode = '手机号格式错误';
        this.errorTry('iphone', 1);
        return false;
      }
      this.errorTry('iphone', 0);
      if (!this.isVerify) {
        this.errorCode = '请完成拼图验证';
        return false;
      }
      this.errorTry('imgVerification', 0);
      if (e && this.ruleForm.smsVerification === '') {
        this.errorCode = '手机验证码不能为空';
        this.errorTry('smsVerification', 1);
        return false;
      }
      this.errorTry('smsVerification', 0);
      return true;
    },
    //- 设置定时器
    setTimeFun (e) {
      let self = this;
      this.countTimeFun = setTimeout(function () {
        if (e > 0) {
          let count = e - 1;
          self.verificationCount = count;
          self.setTimeFun(count);
        } else {
          clearTimeout(self.countTimeFun);
          self.countTimeFun = null;
          self.verificationCount = 0;
        }
      }, 1000);
    },
    //- 确认重置密码
    yesPaw (e) {
      if (this.title.name === '' && (this.title.username === '' || this.title.username === undefined)) {
        this.errorCode = '请选择账号';
        this.errorTry('select', 1);
        return false;
      }
      // if (JSON.stringify(this.pwdconfig) == "{}") {
      //   this.errorCode = '请选择学校';
      //   this.errorTry('select', 1);
      //   return false;
      // }
      if (e.password.length < 8) {
        this.errorCode = '密码长度少于8位';
        this.errorTry('password', 1);
        return false;
      }
      let regx = '';
      if(JSON.stringify(this.pwdconfig) !== '{}'){
        // 密码强度验证
        switch (this.pwdconfig.pwdlevel.level) {
          case 1:
            regx = new RegExp("^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,12}$")
            if(!regx.test(e.password)){
              this.errorCode = '密码必须包含英文（含大小写）+ 数字 + 特殊字符';
              this.errorTry('password', 1);
              return
            }
            break;
          case 2:
            regx = new RegExp("^(?=.*\\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\\da-zA-Z~!@#$%^&*]{8,12}$")
            if(!regx.test(e.password)){
              this.errorCode = '密码必须包含英文+ 数字 + 特殊字符';
              this.errorTry('password', 1);
              return
            }
            break;
          case 3:
            regx = /^(?=.*[a-zA-Z])(?=.*\d).{8,12}$/
            if(!regx.test(e.password)){
              this.errorCode = '密码必须包含英文+ 数字';
              this.errorTry('password', 1);
              return
            }
            break;
          default:
            break;
        }
      }
      else{
        regx = /^(?=.*[a-zA-Z])(?=.*\d).{8,12}$/
        if(!regx.test(e.password)){
          this.errorCode = '密码必须包含英文+ 数字';
          this.errorTry('password', 1);
          return
        }
      }
      if (e.password !== e.password1) {
        this.errorCode = '两次输入的密码不一致';
        this.errorTry('password', 1);
        this.errorTry('password1', 1);
        return false;
      }
      this.errorTry('select', 0);
      this.errorTry('password', 0);
      this.errorTry('password1', 0);
      this.errorCode = '';
      this.pawLoading = true;
      this.title.origin === 'paw' && this.resetPaw();
      this.title.origin === 'renewPaw' && this.upPaw();
    },
    //- 首次登陆 修改密码
    upPaw () {
      const __obj = cloneDeep({
        cpassword: this.paw.password1,
        password: this.paw.password,
        accesstoken: this.title.res.data.accesstoken
      })
      console.log(typeof __obj.password);
      __obj.password = sha1(__obj.password)
      __obj.cpassword = sha1(__obj.cpassword)
      apiUpdatemine(__obj, '1').then(res => {
        console.log(res);
        if (res.code === 0) {
          document.cookie = "accesstoken=" + this.title.res.data.accesstoken + ";path=/";
          localStorage.setItem('user', JSON.stringify(this.title.res.data));
          if(this.isWebSite) {
            emitter.emit('changeLoginStatus')
            this.$emit('close')
            this.dialogVisible = false
          } else {
            this.$router.push({ path: '/index' });
          }
        } else {
          this.errorCode = res.msg;
        }
        this.pawLoading = false;
      }).catch(error => { console.log(error) })
    },
    //- 修改密码
    resetPaw () {
      const __obj = cloneDeep({
        phone: this.ruleForm.iphone,
        username: this.title.username,
        validcode: this.ruleForm.smsVerification,
        imagecaptchatoken: this.imagecaptchatoken,
        moveLength: this.moveLength,
        password: this.paw.password,
        schoolId: this.schoolId
      })
      __obj.password = sha1(__obj.password)
      openapiResetpassword(__obj).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.isYes = true;
          let self = this;
          setTimeout(function () {
            self.dialogVisible = false;
          }, 2000)
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
        this.pawLoading = false;
      }).catch(error => { console.log(error) })
    },
    //- 短信验证确认提交
    yesUp () {
      this.verificationFun();
      if (!this.verificationFun('yes')) {
        return false;
      }
      this.postBindIphone()
    },
    //- 组件显示
    showDialog (e) {
      //这个方法是外部组建触发的
      console.log("showDialog===>", e)
      this.title = e;
      this.getCaptcha();
      this.dialogVisible = true;
      let userMsg = localStorage.getItem("userMsg");
      if (userMsg) {
        const data = JSON.parse(userMsg);
        if(data.schoolMsg.pwdconfig)
          this.pwdconfig = JSON.parse(data.schoolMsg.pwdconfig)
          if(this.pwdconfig && this.pwdconfig.pwdlevel) {
            this.pwdLevel = this.pwdconfig.pwdlevel.level-1
          }
        }
    },
    //- 获取/更新图片二维码
    getCaptcha () {
      this.randomNumber = (Math.random() * 10).toString().slice(-6);
    },
    //手机验证码获取
    getIphoneVaild () {
      let fun = this.title.origin === 'user' ? mobileGetuserinfosmsvalidcode : mobileGetpasswordsmsvalidcode;
      console.log('fun函数', fun, this.title.origin === 'user')
      fun({
        phone: this.ruleForm.iphone,
        imagecaptchatoken: this.imagecaptchatoken,
        moveLength: this.moveLength
      }).then(res => {
        if (res.code === 0) {
          this.verificationCount = 60;
          this.setTimeFun(60);
        } else {
          this.verificationCode(res.msg);
          this.errorCode = res.msg;
        }
      }).catch(error => { console.log(error) })
    },
    //- 绑定手机号/验证手机号
    postBindIphone () {
      this.yesLoading = true;
      let fun = this.title.origin === 'user' ? openapiBindphone : openapiValidsliderpasswordcode;
      fun({
        phone: this.ruleForm.iphone,
        validcode: this.ruleForm.smsVerification,
        imagecaptchatoken: this.imagecaptchatoken,
        moveLength: this.moveLength
      }).then(res => {
        console.log(res)
        if (res.code === 0) {
          // this.$message({
          //   message: this.title.title + '成功',
          //   type: 'success'
          // });
          if (this.title.origin === 'user') {
            this.$emit('yesRetIphone', this.ruleForm.iphone);
            this.dialogVisible = false;
          }
          if (this.title.origin === 'login') {
            this.title = {
              title: '重置密码',
              bottom: '确定',
              origin: 'paw',
              username: res.data.length > 1 ? '' : res.data[0]
            };
            this.userNameArr = res.data.length > 1 ? res.data : [];
            if(res.data.length === 1){
              this.getuserschoollist(res.data[0])
            }
          }
        } else {
          this.verificationCode(res.msg);
          this.errorCode = res.msg;
        }
        this.yesLoading = false;
      }).catch(error => { console.log(error) })
    },
    //- 错误内容判断
    verificationCode (e) {
      let arr = ['手机', '图片', '短信'];
      let sub = ['iphone', 'imgVerification', 'smsVerification'];
      arr.forEach((val, index) => {
        let reg = new RegExp(val);
        if (reg.test(e)) {
          this.errorTry(sub[index], 1);
          // this.$refs[sub[index]].$refs.input.style = 'border:1px solid red;';
        }
      });
    },
    //- 错误框显示
    errorTry (e, type) {
      try {
        type === 1 ? this.$refs[e].$refs.input.style = 'border:1px solid red;' : this.$refs[e].$refs.input.style = '';
      }
      catch (error) {
        console.log(error)
      }
    },
    // 切换用户
    changeUserName(e){
      this.getuserschoollist(e)
    },
    // 切换学校
    changeSchool(e){
      for(let i = 0; i < this.userSchoolArr.length; i++){
        if(this.userSchoolArr[i].schoolId === e && this.userSchoolArr[i].pwdconfig){
          this.pwdconfig = JSON.parse(this.userSchoolArr[i].pwdconfig)
          this.pwdLevel = this.pwdconfig.pwdlevel.level-1
          this.schoolId = this.userSchoolArr[i].schoolId
          break
        }
      }
    },
    // 重置密码-获取登录验证码弹出条件
    getuserschoollist(val) {
      getuserschoollist({ username: val }).then(res => {
        if (res.code === 0) {
          this.userSchoolArr = res.data;
          if(this.userSchoolArr.length == 1 && this.userSchoolArr[0].pwdconfig){
            this.pwdconfig = JSON.parse(this.userSchoolArr[0].pwdconfig)
            this.pwdLevel = this.pwdconfig.pwdlevel.level-1
            this.schoolId = this.userSchoolArr[0].schoolId
          }
        } else {
          this.errorCode = res.msg;
        }
      }).catch(error => { console.log(error) });
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../pages/components/common.scss';
::v-deep .el-dialog {
  border-radius: 20px !important;
}
::v-deep .el-input__prefix {
  left: 9px;
}
::v-deep .el-form-item {
  &:nth-child(2) {
    .el-form-item__content {
      line-height: initial;
    }
  }
  .el-form-item__content {
    justify-content: center;
  }
}
.toolTap {
  width: 100%;
  display: flex;
  height: 30px;
  line-height: 30px;
  margin-bottom: 20px;
  .toolItem {
    cursor: pointer;
    flex: 1;
    text-align: center;
    font-size: 18px;
    position: relative;
    &.actived {
      color: #4e86ff;
      &::after {
        content: "";
        position: absolute;
        left: 46%;
        top: 99%;
        width: 37px;
        height: 5px;
        background-color: #4e86ff;
        border-radius: 30px;
      }
    }
  }
}
::v-deep.rule-form {
  position: relative;
  .img-verification {
    display: inline-block;
  }
  .verification-img {
    display: inline-block;
    vertical-align: top;
    margin-left: 20px;
    margin-top: -5px;
  }
  .sms-ver-number {
    cursor: pointer;
    color: #4e86ff;
    font-size: 16px;
    margin-left: 40px;
    position: absolute;
    right: 0;
    &.noSms {
      color: #999999;
    }
  }
}
.error-code {
  width: 289px;
  height: 38px;
  line-height: 38px;
  background: #fff5f5;
  color: #d44c4c;
  padding-left: 16px;
  padding-right: 16px;
  margin: 10px auto 0;
}
.bottomArea {
  margin-top: 25px;
  .yesBind {
    margin-left: 36px;
  }
}
.note-yes-paw {
  height: 209px;
  padding-top: 50px;
  text-align: center;
  .icon-tongyi {
    font-size: 39px;
    color: #86d490;
  }
  .note-yes-paw-text {
    font-size: 14px;
    color: #333333;
    padding-top: 5px;
  }
}

// 滑动验证码部分
.verify-div{
  position: absolute !important;
  left: 25px;
  top: -125px;
  .slide-verify-div-box{
    padding: 15px 0 68px 0;
    border-radius: 18px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index:999;
    background-color: #fff;
  }
  .slide-verify-title{
    padding:  0 20px;
    padding-bottom: 14px;
    margin-bottom: 18px;
    color: #666666;
    font-size: 14px;
    line-height: initial;
    border-bottom: 1px solid #D8D8D8;
    :nth-child(2){
      position: relative;
      top: -10px;
      font-size: 25px;
      float: right;
      color: #999999;
      cursor: pointer;
    }
  }
  .slide-verify-box{
    padding: 0 10px;
  }
}

.mask{
  width: 1200vw;
  height: 1200vh;
  position: fixed;
  top: -1200vh;
  left: -1200vw;
  transform: translate(30%,73%);
  background: rgba(0, 0, 0, 0.3);
  z-index: 100 ;
}

.note {
  font-size: 12px;
  line-height: 18px;
  color: #666666;
}
</style>